import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { WithdrawStackRoutes, WithdrawStackScreenProps } from './type';
import { WithdrawWebConfirmScreen } from './WithdrawWebConfirm.screen';
import { WithdrawNativeConfirmScreen } from './WithdrawNativeConfirm.screen';

export const WithdrawConfirm: React.FC<WithdrawStackScreenProps<WithdrawStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, func, onReturnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <WithdrawNativeConfirmScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <WithdrawWebConfirmScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
